module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/mobile-additional-integrations@2x-d34d42c496b178acdb3130ba68f22179.png";